/** Constants */
import {
  ANALYTICS_ENTITY_TYPE_ENUMS,
  BEHAVIOUR_NOMENCLATURE_CONSTANTS,
} from "ToddleAnalytics/modules/Constants/ToddleAnalyticsConstants";

export const ENTITY_TYPE_TO_METADATA_ID_MAP = {
  [ANALYTICS_ENTITY_TYPE_ENUMS.behaviourAction]: "behaviour_action_id",
  [ANALYTICS_ENTITY_TYPE_ENUMS.behaviourCategory]: "behaviour_category_id",
  [ANALYTICS_ENTITY_TYPE_ENUMS.behaviourSentiment]: "behaviour_sentiment_id",
  [ANALYTICS_ENTITY_TYPE_ENUMS.behaviourSeverity]: "behaviour_severity_id",
  [ANALYTICS_ENTITY_TYPE_ENUMS.behaviourLocation]: "behaviour_location_id",
  [ANALYTICS_ENTITY_TYPE_ENUMS.grade]: "behaviour_grade_id",
};

export const BEHAVIOUR_SENTIMENT_COLOR_MAP = {
  Positive: "var(--teal-600)",
  Negative: "var(--red-600)",
  Neutral: "var(--neutral-500)",
};

export const IncidentTableColumns = [
  {
    id: "status",
    label: "toddleAnalytics:status",
    type: "CUSTOM",
    alignment: "center",
    style: { width: "40px", fontSize: "14px" },
    fieldUID: "INCIDENT_STATUS",
  },
  {
    id: "uid",
    label: "toddleAnalytics:incident_id_with_nomenclature",
    type: "TEXTCOLUMN",
    style: { width: "77px", fontSize: "14px" },
    fieldUID: "INCIDENT_UID",
    nomenclatureProps: {
      type: BEHAVIOUR_NOMENCLATURE_CONSTANTS["INCIDENT"],
      convertToLowerCase: false,
    },
  },
  {
    id: "studentInvolved",
    label: "toddleAnalytics:student_involved",
    type: "CUSTOM",
    style: { width: "208px", fontSize: "14px" },
    fieldUID: "INCIDENT_STUDENT_INVOLVED",
    excelDownloadDependentUids: [
      {
        fieldUID: "INCIDENT_STUDENT_INVOLVED",
        label: "toddleAnalytics:student_involved",
      },
      {
        fieldUID: "GRADE",
        label: "toddleAnalytics:student_grade",
      },
    ],
    sortType: "toggle",
  },
  {
    id: "category",
    label: "toddleAnalytics:category",
    type: "CUSTOM",
    style: { width: "142px", fontSize: "14px" },
    fieldUID: "BEHAVIOUR_CATEGORY",
    sortType: "toggle",
  },
  {
    id: "incidentName",
    label: "toddleAnalytics:incident_title_with_nomenclature",
    type: "TEXTCOLUMN",
    style: { width: "384px", fontSize: "14px" },
    isDefaultColumn: true,
    fieldUID: "INCIDENT_NAME",
    nomenclatureProps: {
      type: BEHAVIOUR_NOMENCLATURE_CONSTANTS["INCIDENT"],
      convertToLowerCase: false,
    },
  },
  {
    id: "subCategory",
    label: "toddleAnalytics:sub_category",
    type: "TEXTCOLUMN",
    style: { width: "268px", fontSize: "14px" },
    fieldUID: "BEHAVIOUR_SUB_CATEGORY",
    sortType: "toggle",
  },
  {
    id: "location",
    label: "toddleAnalytics:location",
    type: "TEXTCOLUMN",
    style: { width: "156px", fontSize: "14px" },
    fieldUID: "BEHAVIOUR_LOCATION",
    sortType: "toggle",
  },
  {
    id: "sharedWith",
    label: "toddleAnalytics:shared_with",
    type: "CUSTOM",
    style: { width: "270px", fontSize: "14px" },
    fieldUID: "SHARED_WITH",
    excelDownloadDependentUids: [
      {
        fieldUID: "SHARED_WITH_FAMILY",
        label: "common:shared_with_family",
      },
      {
        fieldUID: "SHARED_WITH_INVOLVED_STUDENTS",
        label: "toddleAnalytics:shared_with_involved_students",
      },
    ],
  },
  {
    id: "actions",
    label: "toddleAnalytics:actions_taken_with_nomenclature",
    type: "CUSTOM",
    style: { width: "97px", fontSize: "14px" },
    fieldUID: "INCIDENT_ACTION",
    nomenclatureProps: {
      type: BEHAVIOUR_NOMENCLATURE_CONSTANTS["ACTION"],
      convertToLowerCase: false,
    },
    excelDownloadDependentUids: [
      {
        fieldUID: "ACTION_NAME",
        label: "toddleAnalytics:action_name",
      },
      {
        fieldUID: "REFERRER_NAME",
        label: "toddleAnalytics:referrer_name",
      },
    ],
  },
  {
    id: "level",
    label: "toddleAnalytics:level_with_nomenclature",
    type: "CUSTOM",
    fieldUID: "INCIDENT_SEVERITY",
    style: { width: "93px", fontSize: "14px" },
    nomenclatureProps: {
      type: BEHAVIOUR_NOMENCLATURE_CONSTANTS["LEVEL"],
      convertToLowerCase: false,
    },
  },
  {
    id: "incidentOccuredAt",
    label: "toddleAnalytics:incident_time_with_nomenclature",
    type: "TEXTCOLUMN",
    style: { width: "176px", fontSize: "14px" },
    fieldUID: "INCIDENT_TIME",
    sortType: "toggle",
    nomenclatureProps: {
      type: BEHAVIOUR_NOMENCLATURE_CONSTANTS["INCIDENT"],
      convertToLowerCase: false,
    },
  },
  {
    id: "createdBy",
    label: "toddleAnalytics:created_by",
    type: "CUSTOM",
    style: { width: "268px", fontSize: "14px" },
    fieldUID: "INCIDENT_CREATED_BY",
    sortType: "toggle",
  },
  {
    id: "incidentTime",
    label: "toddleAnalytics:created_on",
    type: "TEXTCOLUMN",
    style: { width: "176px", fontSize: "14px" },
    fieldUID: "INCIDENT_CREATED_AT",
    sortType: "toggle",
  },
  {
    id: "incidentModifiedTime",
    label: "toddleAnalytics:last_modified_on",
    type: "TEXTCOLUMN",
    style: { width: "180px", fontSize: "14px" },
    fieldUID: "INCIDENT_MODIFIED_AT",
    sortType: "toggle",
  },
];

export const FIELDUID_COLUMNID_MAPPING = {
  ENTITY_ID: "id",
  INCIDENT_UID: "uid",
  INCIDENT_STATUS: "status",
  INCIDENT_STUDENT_INVOLVED: "studentInvolved",
  INCIDENT_NAME: "incidentName",
  BEHAVIOUR_CATEGORY: "category",
  BEHAVIOUR_SUB_CATEGORY: "subCategory",
  INCIDENT_ACTION: "actions",
  INCIDENT_SEVERITY: "level",
  BEHAVIOUR_LOCATION: "location",
  INCIDENT_MODIFIED_AT: "incidentModifiedTime",
  INCIDENT_CREATED_BY: "createdBy",
  INCIDENT_CREATED_AT: "incidentTime",
  SHARED_WITH: "sharedWith",
  INCIDENT_TIME: "incidentOccuredAt",
};

export const ACTION_OVERVIEW_CHART_COLORS = [
  "var(--purple-600)",
  "var(--violet-600)",
  "var(--orange-600)",
  "var(--blue-600)",
  "var(--teal-600)",
  "var(--green-600)",
  "var(--yellow-600)",
];

export const STAFF_ROLES = {
  ADMIN: "School Administrator",
  TEACHER: "Teacher",
  ARCHIVED: null,
};

export const SHARED_WITH_LIMIT = 2;

export const BEHAVIOUR_LEVEL_CHART_SORT_ORDER = {
  Low: 1,
  Medium: 2,
  High: 3,
  "Very High": 4,
};

export const BEHAVIOUR_SENTIMENT_CHART_SORT_ORDER = {
  Positive: 1,
  Negative: 2,
  Neutral: 3,
};
